import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("actionLog", {params: params});
  },

  findAllByVbIncomingDoc(id, subDocId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id, subDocId: subDocId}, pageable);
    return httpService.get("actionLog/findAllByVbIncomingDoc", {params: params});
  },

  findAllByVbIncomingDocForConfigLD(id, subDocId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id, subDocId: subDocId}, pageable);
    return httpService.get("actionLog/findAllByVbIncomingDocForConfigLD", {params: params});
  },

  findAllAccessible(id, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({vbIncomingProcessId: id}, pageable);
    return httpService.get("actionLog/findAllAccessible", {params: params});
  },

  findAllByVbOutgoingDoc(id, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({objectId: id}, pageable);
    return httpService.get("actionLog/findAllByVbOutgoingDoc", {params: params});
  },

  findAllByVbOutgoingDocForCongigLD(id, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({objectId: id}, pageable);
    return httpService.get("actionLog/findAllByVbOutgoingDocForConfigLD", {params: params});
  },

  findAllForHcCaseCommands(hcCaseCommandsId, hcCaseCommandsCommonId) {
    let params = {hcCaseCommandsId: hcCaseCommandsId, hcCaseCommandsCommonId: hcCaseCommandsCommonId};
    return httpService.get("actionLog/findAllForHcCaseCommands", {params: params});
  },

  findAllByVbOutgoingDocForBlockedRole(id, blockedUserId, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({objectId: id, blockedUserId: blockedUserId}, pageable);
    return httpService.get("actionLog/findAllByVbOutgoingDocForBlockedRole", {params: params});
  },

  findAllByVbOutgoingDocForConfigTHVP(id, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id}, pageable);
    return httpService.get("actionLog/findAllByVbOutgoingDocForConfigTHVP", {params: params});
  },

  findAllByVbIncomingDocForBlockedRole(id, blockedUserId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id, blockedUserId: blockedUserId}, pageable);
    return httpService.get("actionLog/findAllByVbIncomingDocForBlockedRole", {params: params});
  },

  findFullHistoryByVbIncomingDocForBlockedRole(id, blockedUserId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id, blockedUserId: blockedUserId}, pageable);
    return httpService.get("actionLog/findFullHistoryByVbIncomingDocForBlockedRole", {params: params});
  },

  findAllByVbIncomingDocForConfigTHVP(id, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id}, pageable);
    return httpService.get("actionLog/findAllByVbIncomingDocForConfigTHVP", {params: params});
  },

  findFullHistoryByVbIncomingDoc(id, subDocId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id, subDocId: subDocId}, pageable);
    return httpService.get("actionLog/findFullHistoryByVbIncomingDoc", {params: params});
  },

  findAllByVbOutgoingDocForPykHDTV(pykId, vbId, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({objectIdPYK: pykId, objectIdVb: vbId}, pageable);
    return httpService.get("actionLog/findAllByVbOutgoingDocPykHDTV", {params: params});
  },

}



// WEBPACK FOOTER //
// ./src/services/actionLogService.js